import { environment } from './environment';

// Browser-side OAuth 2.0 Authorization Code + PKCE against Cognito hosted UI.
// No backend-for-frontend: the browser exchanges the code directly at Cognito
// /oauth2/token. The web app client is configured with `generate_secret = false`
// (see infra/code/cognito.tf), which is what makes public PKCE legal.
//
// Cognito's registered callback for the web client is `<origin>/callback`, so
// redirect_uri must match that exactly — it's part of both the /authorize and
// /token requests.

export const REDIRECT_PATH = '/callback';
export const LOGOUT_PATH   = '/';

export const authConfig = {
  domain:   environment.cognito.domain,
  clientId: environment.cognito.clientId,
  scopes:   environment.cognito.scopes,
  region:   environment.cognito.region,
  redirectUri: () => `${window.location.origin}${REDIRECT_PATH}`,
  logoutUri:   () => `${window.location.origin}${LOGOUT_PATH}`,
};

export const authorizeEndpoint = () => `${authConfig.domain}/oauth2/authorize`;
export const tokenEndpoint     = () => `${authConfig.domain}/oauth2/token`;
export const logoutEndpoint    = () => `${authConfig.domain}/logout`;
